import { useSearchParams } from 'react-router-dom';

export const useAddRemoveQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const add = (key: string, value: string) => {
        const newSearchParams = new URLSearchParams(searchParams.toString());
        newSearchParams.set(key, value);
        setSearchParams(newSearchParams);
    };
    const remove = (key: string) => {
        const newSearchParams = new URLSearchParams(searchParams.toString());
        newSearchParams.delete(key);
        setSearchParams(newSearchParams);
    };
    return { add, remove };
};
